import { useState, useContext, useEffect, useRef } from "react";
import { DateTime } from "luxon";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  CardHeader,
  Col,
  Row,
  Button,
  ButtonGroup,
} from "reactstrap";
import AppContext from "../../contexts/appContext";
import { createChart, updateChart } from "../../modules/callCharts";

import "../testing/media.css";
import { HOST_SERVICE } from "../../modules/bm";
import { CHART_COLORS } from "../../modules/helper";

const keepProps = (array, category) => {
  const firstObject = array && array.length > 0 ? array[0] : null;
  if (firstObject) {
    const props = Object.keys(firstObject);
    const filteredProps = props.filter(
      (prop) =>
        prop !== "category" &&
        prop !== "created" &&
        prop !== "days" &&
        prop !== "success" &&
        prop !== "rate" &&
        prop !== "count" &&
        prop !== "countWithError" &&
        prop !== "_id"
    );
    return filteredProps;
  }
  return [];
};

function GlobalMonthTrafficChart({ dispatch }) {
  const appState = useContext(AppContext);
  const chartMonthGlobalTraffic = useRef();
  const [series, setSeries] = useState([]);
  const [props, setProps] = useState([]); // To store the list of properties from services
  const [selectedProps, setSelectedProps] = useState("users");
  const [selectedSeries, setSelectedSeries] = useState([]);

  const CHART_MAIN_COLOR = {
    duration: CHART_COLORS.pink,
    users: CHART_COLORS.yellow,
    conferences: CHART_COLORS.blue,
    sent: CHART_COLORS.orange,
    received: CHART_COLORS.darkblue,
    traffic: CHART_COLORS.cyan,
    successRate: CHART_COLORS.orange,
  };

  const PROPSLABEL = {
    duration: "Monthly Duration (in minutes)",
    traffic: "Monthly Traffic (in MB)",
    users: "Monthly Users (number)",
    conferences: "Monthly Conferences (number)",
    sent: "Monthly Traffic sent (in MB)",
    received: "Monthly Traffic received (in MB)",
    successRate: "Monthly Success Rate (in percent)",
  };

  const getLabels = (prop) => {
    switch (prop) {
      case "status":
        return ["", "success", "warning", "error", "unknown"];
      default:
        return null;
    }
  };

  const changeSeries = (selectedProps, series) => {
    if (series.length > 0) {
      const graphSeries = series.map((elt) => ({
        x: DateTime.fromISO(
          `${elt._id.year}-${
            elt._id.month < 10 ? `0${elt._id.month}` : elt._id.month
          }-01`
        )
          .startOf("month")
          .toJSON(),
        y: elt[selectedProps],
      }));
      setSelectedSeries(graphSeries);
    }
  };

  const getButtonsList = (items) => {
    return items.map((item, index) => (
      <Button
        key={index}
        color="info"
        id="0"
        size="sm"
        tag="label"
        className={classNames("btn-simple", {
          active: selectedProps === item,
        })}
        onClick={() => {
          setSelectedProps(item);
        }}
      >
        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
          {item}
        </span>
        <span className="d-block d-sm-none">
          <i className="tim-icons icon-single-02" />
        </span>
      </Button>
    ));
  };

  useEffect(() => {
    if (selectedSeries.length > 0) {
      updateChart(
        selectedSeries,
        null,
        chartMonthGlobalTraffic,
        2,
        60000,
        true
      );
    }
  }, [selectedSeries]);

  useEffect(() => {
    changeSeries(selectedProps, series);
  }, [series]);

  useEffect(() => {
    createChart(
      document.querySelector("#chartMonthGlobalTraffic"),
      chartMonthGlobalTraffic,
      "MONTHLY",
      {
        prop: PROPSLABEL[selectedProps],
        colorProp: CHART_MAIN_COLOR[selectedProps],
        maxY: 60000,
        isLine: false,
        labels: getLabels(selectedProps),
        unit: "month",
      }
    );
    changeSeries(selectedProps, series);
  }, [selectedProps]);

  useEffect(() => {
    if (appState.summary && appState.summary.monthly) {
      setSeries(appState.summary.monthly);
      setProps(keepProps(appState.summary.monthly));
    }
  }, [appState.summary]);

  return (
    <Card className="card">
      <CardHeader>
        <Row>
          <Col className="text-left" sm="6">
            <h5 className="card-category">Cumulative traffic per month</h5>
            <CardTitle tag="h3">MONTHLY TRAFFIC</CardTitle>
          </Col>
          <Col className="text-left" sm="6">
            <ButtonGroup
              className="btn-group-toggle float-right"
              data-toggle="buttons"
            >
              {getButtonsList(props)}
            </ButtonGroup>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Row>
          <Col md="12">
            <div className="chart-container">
              <canvas id="chartMonthGlobalTraffic"></canvas>
            </div>
          </Col>
        </Row>
      </CardBody>
      <CardFooter></CardFooter>
    </Card>
  );
}

export default GlobalMonthTrafficChart;
